import { html as a } from "@microsoft/fast-element";
const l = a`
  <img
    class="control"
    part="control"
    src="${(t) => t.imageUrl}"
    alt="${(t) => t.alt}"
  />
`;
export {
  l as avatarTemplate
};
